<template>
  <div class="search">
    <div class="xh-topbg">
      <div class="index-header">
        <img class="logo" src="@/assets/img/company-xh.png"/>
        <div class="search" @click="searchPage"><van-icon name="sousuo"></van-icon><span>搜索职位/公司…</span></div>
      </div>
      <van-dropdown-menu class="filter" active-color="#1C54CF">
        <van-dropdown-item v-model="jobType" :options="jobTypeList" />
        <van-dropdown-item title="选择行业" @open="showIndustrySelect" />
        <van-dropdown-item title="仅看推荐" @open=""/>
        <van-dropdown-item title="智能筛选" @open="showFilterPop"/>
      </van-dropdown-menu>
    </div>
    <ul class="company-list-simple">
      <li v-for="item in companySimple" :key="item.index" @click="companyDetail">
        <img :src="item.logo"/>
        <div class="detail-info">
          <h3>{{item.name}}</h3>
          <ul class="feature">
            <li v-for="feature in item.featurelist" :key="feature.index">
              {{feature.detail}}
            </li>
          </ul>
          <div class="jobs">
            <div class="place">{{item.place}}</div>
            <div class="num">
              在招职位 <span>{{item.jobs}}</span> 个
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!--智能筛选-->
    <transition name="fade">
      <div class="filter-cont" v-show="filterPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenPop"></van-icon>
          <h2>智能筛选</h2>
        </div>
        <h3>期望月薪 <small>（单选/元）</small> </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in salaryList" :key="item.index" :class="{checked:index==n}" @click="selectSalary(index)"><span>{{item}}</span></li>
        </ul>
        <h3>工作年限 <small>（单选）</small> </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in seniority" :key="item.index" :class="{checked:index==year}" @click="selectSeniority(index)"><span>{{item}}</span></li>
        </ul>
        <h3>学历要求 <small>（多选）</small> </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in educationList" :data-index="index" :key="item.index"  @click="selectEducation(index)" :class="{checked:item.check}"><span>{{item.education}}</span></li>
        </ul>
        <h3>福利筛选 <small>（多选）</small> </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in welfareList" :data-index="index" :key="item.index"  @click="selectWelfare(index)" :class="{checked:item.check}"><span>{{item.welfare}}</span></li>
        </ul>
        <div class="fixed-bottom">
          <van-button type="primary" class="btn-gray" color="#EEEFF1" round>清 除</van-button>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>确 定</van-button>
        </div>
      </div>
    </transition>
    <!--选择行业-->
    <transition name="van-fade">
      <div class="job-pop" v-show="industrySelect" style="padding-bottom: 100px;">
        <div class="pop-header"><van-icon @click="industrySelect = false" name="fanhui"></van-icon>选择行业</div>
        <h2>请选择您的期望行业</h2>
        <van-search v-model="search" placeholder="请输入关键词搜索您的行业类型" />
        <van-tree-select
          :items="items"
          height="100%"
          :active-id.sync="activeId"
          :main-active-index.sync="activeIndex"
        />
        <div class="fixed-bottom">
          <div class="selected">
            <span>已选：</span>
            <ul>
              <li v-for="item in selectedList" :key="item.index">{{item}}</li>
            </ul>
          </div>
          <div class="btn-cont">
            <van-button type="primary" class="btn-gray" color="#EEEFF1" round>清 除</van-button>
            <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>确 定</van-button>
          </div>
        </div>
      </div>
    </transition>
    <navBar></navBar>
  </div>
</template>

<script>
import navBar from './../components/navbar'
export default {
  name: 'companyList',
  components: {
    navBar
  },
  data() {
    return {
      jobType: '0',
      area: '01',
      n: 0,
      industrySelect:false,
      year: 0,
      filterPop: false,
      urgentRecruitment: '仅看急招',
      jobTypeList: [
        { text: '职位类型', value: '0' },
        { text: '类型2', value: '1' },
        { text: '类型3', value: '2' }
      ],
      areaList: [
        { text: '区镇街道', value: '01' },
        { text: '全嘉定', value: 'a' },
        { text: '马陆镇', value: 'b' },
        { text: '江桥', value: 'c' },
        { text: '南翔镇', value: 'd' },
        { text: '销徐行量排序', value: 'e' },
        { text: '外冈', value: 'f' },
        { text: '安亭', value: 'g' }
      ],
      selectedList: ['电影/录音制作', '文化艺术/娱乐', '多媒体', '电影/录音制作', '文化艺术/娱乐', '多媒体'],
      search: '',
      items: [
        { text: '人事', children: [{ text: '教育培训类', id: 11 }, { text: '互联网运营类', id: 12 }, { text: '其他', id: 13 }] },
        { text: '财务', children: [{ text: '教育培训类', id: 21 }, { text: '互联网运营类', id: 22 }] },
        { text: '行政', children: [{ text: '行政专员', id: 11 }, { text: '行政主管/办公室主任', id: 12 }, { text: '行政经理', id: 13 }, { text: '行政总监', id: 14 }] }
      ],
      activeId: [1, 2],
      activeIndex: 0,
      companySimple: [
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo3.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo1.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo3.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo1.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo3.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        },
        {
          logo: require('@/assets/img/logo1.jpg'),
          name: '上海良信电器股份有限公司',
          jobs: '39430',
          place: '嘉定区',
          featurelist: [
            {
              detail: '已上市'
            }, {
              detail: '1000人以上'
            }, {
              detail: '移动互联网'
            }
          ]
        }
      ],
      salaryList: ['不限', '3000以下', '3000-4500', '3000以下', '3000以下', '3000以下', '3000以下', '3000以下', '3000以下'],
      seniority: ['不限', '一年以下', '1-2年', '3-5年', '6-7年', '8-10年', '10年以上'],
      educationList: [
        { education: '不限', check: true },
        { education: '初中及以下', check: false },
        { education: '中专/中技', check: false },
        { education: '高中', check: false },
        { education: '大专', check: false },
        { education: '本科', check: false },
        { education: '硕士', check: false },
        { education: '博士', check: false }
      ],
      welfareList: [
        { welfare: '不限', check: true },
        { welfare: '五险一金', check: false },
        { welfare: '包吃', check: false },
        { welfare: '包住', check: false },
        { welfare: '年底双薪', check: false },
        { welfare: '周末双休', check: false },
        { welfare: '交通补助', check: false },
        { welfare: '加班补助', check: false },
        { welfare: '话补', check: false },
        { welfare: '房补', check: false }
      ]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    searchPage() {
      this.$router.push({ path: '/demo/searchJob' })
    },
    companyDetail() {
      this.$router.push({ path: '/demo/companyDetail' })
    },
    selectSalary(index) {
      this.n = index
    },
    selectSeniority(index) {
      this.year = index
    },
    selectEducation(idx) {
      var check = this.educationList[idx].check
      this.educationList[idx].check = !check
    },
    selectWelfare: function(idx) {
      var check = this.welfareList[idx].check
      this.welfareList[idx].check = !check
    },
    hiddenPop() {
      this.filterPop = false
    },
    showFilterPop() {
      this.filterPop = true
    },
    showIndustrySelect(){
      this.industrySelect = true
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/.van-popup{
    border-radius: 0 0 10px 10px;
    min-height: auto;
  }
  /deep/.filter{
    background: #1C54CF;
    width: 100%;
    padding:0;
    .van-dropdown-menu__bar{
      width: 100%;
      background: none;
      .van-ellipsis{
        color:#CCD9F5;
      }
    }
    .van-cell__value{
      display: none;
    }
    .van-cell__title{
      text-align: center;
    }
  }

  .index-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:16px;
    flex-direction: row;
    background: #1C54CF;
    .logo{
      width: 104px;
      height: 24px;
      line-height: 1;
    }
    .search{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      flex:1;
      color:#fff;
      height: 30px;
      border-radius: 50px;
      background: rgba(255,255,255,.3);
      margin-left: 16px;
      span{
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }
  .search-condition{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:10px 16px 20px;
    ul{
      display: flex;
      align-items: center;
      li{
        color:#B7BABF;
        font-size: 12px;
        padding:6px 12px;
      }
      &.condition{
        .select{
          background: #F5F2EF;
          color:#2E3133;
          border-radius: 50px;
        }
      }
      &.pop-select{
        li{
          position: relative;
          &:after{
            content: '\e629';
            position: absolute;
            right:-6px;
            top:8px;
            font-family: van-icon;
          }
        }
      }
    }
  }
  .company-list-simple{
    margin-left: 0;
    margin-right: 0;
    &> li{
      border-bottom: 8px solid #F7F7F7;
      padding-bottom: 16px;
      padding-left: 16px;
      padding-right: 16px;
      align-items: flex-start;
      &:last-child{
        border-bottom: 0;
      }
      .detail-info{
        h3{
          font-size: 16px;
          margin-bottom: 8px;
        }
      }
      .jobs{
        color:#3A3A3A;
        margin-left: -16px;
        font-size: 14px;
        &:after{
          content: '\e603';
          font-size: 10px;
          position: absolute;
          right:-10px;
          top:50%;
          margin-top: -5px;
          font-family: van-icon;
          color:#C6CDD6;
        }
        .num{
          color:#606060
        }
      }
    }
  }
  .btn-cont{
    padding:10px 16px 20px;
    button{
      &.btn-gray{
        flex:1;
        margin-right: 15px;
      }
      &.btn-blue{
        flex:2;
      }
    }
  }
  .job-pop{
    position: fixed;
    left:0;
    bottom:0;
    right:0;
    background: #fff;
    top:0;
    z-index: 999;
    .fixed-bottom{
      z-index: 9999;
      flex-direction: column;
      .btn-cont{
        width: 100%;
        display: flex;
        padding:0;
        button{
          &.btn-gray{
            flex:1;
            margin-right: 10px;
          }
          &.btn-blue{
            flex:3;
          }
        }
      }
      .selected{
        width: 100%;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        span{
          color:#B6B9BF;
          margin-right: 5px;
        }
        ul{
          display: flex;
          overflow: auto;
          &::-webkit-scrollbar{
            display: none;
          }
          li{
            background: #E4EBFB;
            border:1px solid #4469E3;
            color: #4469E3;
            padding:2px 24px 2px 10px;
            border-radius: 50px;
            margin:0 3px;
            font-size: 12px;
            position: relative;
            &:after{
              content: '\e926';
              position: absolute;
              font-family: van-icon;
              top:54%;
              right:8px;
              transform: translate(0,-50%);
            }
          }
        }
      }
    }
    .pop-header{
      display: flex;
      justify-content: center;
      height: 50px;
      border-bottom: 1px solid #eee;
      align-items: center;
      color:#303132;
      position: relative;
      font-size: 16px;
      background: #fff;
      i{
        position: absolute;
        left: 20px;
        top:50%;
        margin-top: -8px;
      }
    }
    h2{
      padding:22px 16px 0;
      color:#333;
      font-size: 22px;
      font-weight: bold;
      background: #fff;
    }
    .van-search{
      padding-left: 6px;
      padding-right: 6px;
      padding-bottom: 10px;
      .van-search__content{
        background: rgba(231, 236, 243, .3);
        border-radius: 50px;
        height: 40px;
        .van-cell{
          padding:0 6px;
          line-height: 40px;
          /deep/input{
            padding-left: 6px;
            padding-top: 2px;
            &::placeholder{
              color:#C9CCD2
            }
          }
          /deep/i{
            color:#E7ECF3;
          }
        }
      }
    }
    .jobs{
      display: flex;
      flex-direction: column;
      li{
        padding:20px 0;
        margin:0 20px;
        border-bottom: 1px solid #eee;
        position: relative;
        font-size: 16px;
        color:#5C5D5F;
        &.checked{
          color:#2F72F6;
        }
        &:after{
          content: '\e603';
          position: absolute;
          right:20px;
          top: 50%;
          margin-top: -7px;
          font-size: 16px;
          font-family: van-icon;
          color:#929292
        }

      }
    }
    &.job-pop2{
      background: rgba(0,0,0,.7);
      /deep/.van-tree-select{
        margin-left: 60px;
      }
    }
  }
  /deep/.van-tree-select{
    .van-sidebar-item--select::before{
      background: #2F72F6;
    }
    .van-sidebar-item--select,.van-tree-select__item--active{
      color:#2F72F6
    }
  }

</style>
